export const usePrintUtils = () => {
    const convertReceiptListToObject = (result: any) => {
        let customerKeepInfo = "";
        let employeeSubmissionInfo = "";

        if(result) {
            result.map((info: any) => {

                switch(info.type){
                  case "CUSTOMER_KEEP":
                    customerKeepInfo = info.data;
                    break;
                  
                  case "EMPLOYEE_SUBMISSION":
                    employeeSubmissionInfo = info.data;
                    break;
                }
            });
        }
        
        return {
            customerKeepInfo, employeeSubmissionInfo
        }; 
    }

    return {
        convertReceiptListToObject
    };
}